import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { getLLMUsageTier } from "../graphql/queries";
import { createLLMUsageTier } from "../graphql/mutations";
import {
  GetLLMUsageTierQuery,
  CreateLLMUsageTierMutation,
  LLMUsageTier,
  LLMUsageTierStatus,
} from "../API";

export async function cloneLLMUsageTier(
  tierId: string
): Promise<GraphQLResult<CreateLLMUsageTierMutation>> {
  // Load the prior tier
  const priorRes = (await API.graphql(
    graphqlOperation(getLLMUsageTier, { id: tierId })
  )) as GraphQLResult<GetLLMUsageTierQuery>;
  const prior = priorRes.data?.getLLMUsageTier as unknown as LLMUsageTier | undefined;
  if (!prior) throw new Error("Usage tier not found");

  const baseId = prior.baseUsageTierId ?? prior.id; // v1 has null base; set base to prior.id
  const version = (prior.version ?? 1) + 1;

  // Create the new DRAFT version, clear timestamps
  return API.graphql(
    graphqlOperation(createLLMUsageTier, {
      input: {
        projectId: prior.projectId,
        status: LLMUsageTierStatus.DRAFT,
        name: prior.name,
        description: prior.description ?? "",
        version,
        activeAt: null,
        inactiveAt: null,
        priorUsageTierId: prior.id,
        baseUsageTierId: baseId,
        replenishmentPeriod: prior.replenishmentPeriod,
        replenishmentMethod: prior.replenishmentMethod,
        usageLimitAction: prior.usageLimitAction,
        standardTokenReplenishmentAmount: prior.standardTokenReplenishmentAmount ?? 0,
        premiumTokenReplenishmentAmount: prior.premiumTokenReplenishmentAmount ?? 0,
        superPremiumTokenReplenishmentAmount: prior.superPremiumTokenReplenishmentAmount ?? 0,
        reasoningTokenReplenishmentAmount: prior.reasoningTokenReplenishmentAmount ?? 0,
        standardCallReplenishmentAmount: prior.standardCallReplenishmentAmount ?? 0,
        premiumCallReplenishmentAmount: prior.premiumCallReplenishmentAmount ?? 0,
        superPremiumCallReplenishmentAmount: prior.superPremiumCallReplenishmentAmount ?? 0,
        reasoningCallReplenishmentAmount: prior.reasoningCallReplenishmentAmount ?? 0,
        standardTokenUnlimited: prior.standardTokenUnlimited ?? false,
        premiumTokenUnlimited: prior.premiumTokenUnlimited ?? false,
        superPremiumTokenUnlimited: prior.superPremiumTokenUnlimited ?? false,
        reasoningTokenUnlimited: prior.reasoningTokenUnlimited ?? false,
        standardCallUnlimited: prior.standardCallUnlimited ?? false,
        premiumCallUnlimited: prior.premiumCallUnlimited ?? false,
        superPremiumCallUnlimited: prior.superPremiumCallUnlimited ?? false,
        reasoningCallUnlimited: prior.reasoningCallUnlimited ?? false,
      },
    })
  ) as Promise<GraphQLResult<CreateLLMUsageTierMutation>>;
}
